import makeStyles from '@mui/styles/makeStyles';

const useCustomAlertStyles = makeStyles({
  root: {}
});

export default useCustomAlertStyles;
